import { TableCell, TableCellLabel } from '@spotify-internal/data-table';

export const EmptyCell = () => (
  <TableCell>
    <TableCellLabel>—</TableCellLabel>
  </TableCell>
);
